module.exports = __webpack_public_path__ + "static/media/no_wallet_stats.90a3f20f.png";